module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"create-es6-js","commonjs":"create-es6-js","commonjs2":"create-es6-js","amd":"create-es6-js"}
// module id = 1
// module chunks = 0